// extracted by mini-css-extract-plugin
export default {"loading-page":"LoadingPage_loading-page__gGXzP"};